import IhmException from '@ch-types/CoralExceptionTypes/IhmException';

export default class RetryableException extends IhmException {}
